import { render, staticRenderFns } from "./ColorScheme.vue?vue&type=template&id=0394b60d&scoped=true&"
import script from "./ColorScheme.vue?vue&type=script&lang=js&"
export * from "./ColorScheme.vue?vue&type=script&lang=js&"
import style0 from "./ColorScheme.vue?vue&type=style&index=0&id=0394b60d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394b60d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSelect,VSwitch})
